import { RefObject, useEffect } from 'react';

export const useOutsideAlerter = (ref: RefObject<any>, cb: () => void, isSticky?: boolean) => {
    useEffect(() => {
        if (!isSticky) {
            /**
            * Alert if clicked on outside of element
            */
            function handleClickOutside(event: MouseEvent) {
                if (ref.current && !ref.current.contains(event.target)) {
                    cb();
                }
            }
            // Bind the event listener
            document.addEventListener('mousedown', handleClickOutside, false);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [ref, cb, isSticky]);
};
